'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIAvatarHoverlay;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _omit = require('../utils/underscore/omit');

var _omit2 = _interopRequireDefault(_omit);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _UIHoverlay = require('./UIHoverlay');

var _UIHoverlay2 = _interopRequireDefault(_UIHoverlay);

var _UIFlex = require('../layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIAvatarHoverlay(props) {
  var className = props.className,
      text = props.text,
      rest = _objectWithoutProperties(props, ['className', 'text']);

  return _react2.default.createElement(_UIHoverlay2.default, _extends({
    foregroundContent: _react2.default.createElement(
      _UIFlex2.default,
      { align: 'center', justify: 'center' },
      _react2.default.createElement(
        'div',
        { className: 'private-avatar-hoverlay__foreground-text' },
        text || _I18n2.default.text('salesUI.UIAvatarHoverlay.text')
      )
    )
  }, rest, {
    _blur: false,
    className: (0, _classnames2.default)('private-avatar-hoverlay', 'display-inline-block', className)
  }));
}

UIAvatarHoverlay.propTypes = _extends({}, (0, _omit2.default)(_UIHoverlay2.default.propTypes, 'use'), {
  text: _propTypes2.default.node
});

UIAvatarHoverlay.displayName = 'UIAvatarHoverlay';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/overlay/UIAvatarHoverlay.js
// module id = 519
// module chunks = 177